<terra-welcome-layout [showReleaseNotification]="false">
  <section class="welcome-text">Welcome back</section>

  <section class="welcome-sub-text">
    Stay on top of your investments with advanced reports and updates from your real estate GPs
  </section>

  <section class="form-content">

    <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
      <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
    </ng-container>

    <form class="form terra-error-style" [formGroup]="loginForm" (ngSubmit)="login()">
      <h1>Log in</h1>

      <p class="goto-register">
        Don’t have an account yet?
        <a class="link" [routerLink]="routingService.signupLpPage" queryParamsHandling="preserve"
           routerLinkActive="active">Sign up</a>
      </p>


      <mat-form-field appearance="outline" class="input-width">
        <input matInput placeholder="Email" formControlName="username" />
        <mat-error *ngIf="loginForm.get('username').hasError('email')"> Please enter a valid email address</mat-error>
        <mat-error *ngIf="loginForm.get('username').hasError('required')"> Email is required</mat-error>
      </mat-form-field>


      <mat-form-field appearance="outline" class="input-width">
        <input matInput [type]="showPassword ? 'text' : 'password'" placeholder="Password" formControlName="password"
               class="lo_sensitive"/>
        <mat-icon *ngIf="!isLoading" matSuffix (click)="showPassword = !showPassword"
                  class="show-password-icon notranslate" color="primary">remove_red_eye
        </mat-icon>
        <mat-error *ngIf="loginForm.get('password').hasError('required')"> Password is required</mat-error>
      </mat-form-field>
      <a [routerLink]="paths.FORGOT_PASSWORD" routerLinkActive="active" class="light link forgot-password-link">Forgot
        your password?</a>
      <ngx-recaptcha2 #recaptcha formControlName="recaptcha" class="recaptcha"
                      [siteKey]="appSettingsService.recaptchaPublicKey">
      </ngx-recaptcha2>
      <mat-error *ngIf="loginErrors.captcha && loginForm.get('recaptcha').hasError('required')" class="recaptcha-error">
        Please verify you're not a robot
      </mat-error>


      <div class="input-width">
        <button type="submit" mat-flat-button class="tall-button" color="primary" [disabled]="isLoading">
          Log In
        </button>
      </div>


      <div class="error-container" *ngIf="loginErrors.suspended || loginErrors.message || loginErrors.credentialsErrorVisible">
        <p *ngIf="loginErrors.suspended" class="error-message">This account is suspended. Please contact support</p>
        <p *ngIf="loginErrors.message" class="error-message">{{ loginErrors.message }}</p>
        <p *ngIf="loginErrors.credentialsErrorVisible" class="error-message">Email or password is incorrect or bot
          verification failed.</p>
      </div>
    </form>


    <div [ngClass]="{'social-plugins':true, 'social-plugins-blur':!(ssoLoader$ | async)}">
      <button type="button" (click)="signInWithExternalProvider(externalProviderIds.facebook)" [disabled]="!(ssoLoader$ | async)">
        <img src="/assets/images/icons/facebook-icon.svg" alt=""/>
        Facebook
      </button>
      <asl-google-signin-button type='standard' size='large' />
    </div>
    <terra-loader class="ssoLoader" *ngIf="!(ssoLoader$ | async)" />

    <div class="authorized-uk">
      <mat-icon class="notranslate">verified_user</mat-icon>
      Authorised by the UK FCA
    </div>

    <terra-loader [centerToParent]="true" *ngIf="isLoading" />

    <div class="data-safe"><img src="/assets/images/icons/data-safe.png"/></div>
  </section>
</terra-welcome-layout>
